import { Card, Heading, Inline, Stack, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { CarrierLogo } from '@eti/components';
import { constants } from '@eti/utils';
import type { FrequentFlyerCardType } from '../../../models';

const inlineStyles = css`
  justify-content: space-between;
`;

const carrierLogoStyles = css`
  height: 30px;
  width: 30px;
`;

interface PassengerFrequentFlyerCardProps {
  frequentFlyerCard: NonNullable<FrequentFlyerCardType>;
}

const PassengerFrequentFlyerCard = ({ frequentFlyerCard }: PassengerFrequentFlyerCardProps) => {
  const { t } = useTranslation();
  return (
    <Card>
      <Stack spacing={8}>
        <Heading data-testid="passenger-frequent-flyer-card-title" level={3}>
          {t('OrderDetails.Passenger.Drawer.FrequentFlyerCard.Title')}
        </Heading>
        <Inline alignY="center" className={inlineStyles}>
          <Text
            className={constants.MOUSE_FLOW_CLASS_NAMES}
            data-testid="passenger-frequent-flyer-card-number"
          >
            {frequentFlyerCard.number}
          </Text>
          <CarrierLogo
            className={carrierLogoStyles}
            data-testid="passenger-frequent-flyer-card-carrier-logo"
            id={frequentFlyerCard.cardType ?? ''}
            imageAlt={frequentFlyerCard.cardTypeName ?? ''}
          />
        </Inline>
      </Stack>
    </Card>
  );
};

export default PassengerFrequentFlyerCard;
